import * as React from "react";
import { Tabs } from "antd";
import AssetReport from "../Asset Report/AssetReport";
import AssetSummaryReport from "../Asset Summary Report/AssetSumReport";
import PPE from "../PPE Report/ppeReport";
import DisposalAssetReport from "../Disposal Report/AssetSumReport";
import AssetRevaluationReport from "../Asset Revalutation Report/AssetRevaluationReport";
import ExhaustedAssetReport from "../Exhausted Asset Report/ExhaustedAssetReport";
import BranchesAssetSummaryReport from "../Branches Assets Summary Report/BranchesSummaryReport";
import "./style.scss";
import { Helmet } from "react-helmet-async";
export default function TangibleReport() {
  const items = [
    { key: "1", label: "Asset Report", children: <AssetReport /> },
    { key: "2", label: "Summary Report", children: <AssetSummaryReport /> },
    {
      key: "3",
      label: "Locations Report",
      children: <BranchesAssetSummaryReport />,
    },
    { key: "4", label: "PPE Report", children: <PPE /> },
    { key: "5", label: "Disposal Report", children: <DisposalAssetReport /> },
    {
      key: "6",
      label: "Revaluation Report",
      children: <AssetRevaluationReport />,
    },
    {
      key: "7",
      label: "Exhausted Report",
      children: <ExhaustedAssetReport />,
    },
  ];

  return (
    <div>
      <Helmet>
        <title>Tangible Assets Report | Assets Register</title>
      </Helmet>
      <Tabs items={items} defaultActiveKey='1' type='card' />
    </div>
  );
}
